export default __webpack_public_path__ + "static/media/about-us.a4c246fa.jpg";